import PageTitle from 'components/title'
import InputXL from 'components/inputXL'
import InputValidationList from 'components/inputValidationList'
import WORDING from 'constants/wording'

export default function AliasInput({
  inputText,
  setDisabled,
  otherStyles = ''
}) {
  const { ALIAS, ALIAS_SUBTITLE } = WORDING
  return (
    <>
      <PageTitle
        subTitleText={ALIAS_SUBTITLE}
        margins='mt-o md:mt-4'
        otherStyles={otherStyles}
      />

      <p className='mt-5 text-center text-xs font-bold text-gray-700 uppercase'>
        {ALIAS}
      </p>

      {/* Input Xxl */}
      <InputXL inputText={inputText} />

      {/* Input Requirements */}
      <InputValidationList setDisabled={setDisabled} />
    </>
  )
}
